import React from 'react';
import './GradeDetail.css';

const GRADE_DATA = {
  '3': {
    title: '3rd Grade — Basic Electronics',
    projects: [
      'Blinking LED', 'LED control using switch', 'Motor control with switch',
      'Buzzer control with switch', 'Diode functionality', 'Capacitor charging & discharging',
      'LED blinker using transistor', 'Automatic night light', 'Water level indicator',
      'Smart clap', 'LED dimmer', 'Motor speed controller',
      'IR Remote controller without controller', 'Wired robot without microcontroller', 'Edge Detecting Robot without controller',
    ],
    info: '32 hours/year · Weekly once · 45–60 min/session · Certificate of completion provided',
  },
  '4': {
    title: '4th Grade — Circuits & Sensors',
    projects: [
'LED Polarity Tester',
'Resistor Color Code Identifier Board',
'Motor Control with Switch',
'Buzzer using Switch',
'Buzzer, Motor & LED with and without Resistor',
'One Way Direction Flow using Diode',
'Capacitor Charging & Discharging Light Experiment',
'LED Blinker using Transistor',
'Darkness Sensor (LDR Automatic Lamp)',
'Water Level Indicator',
'Smart Clap Switch',
'Series & Parallel Circuit',
'Railway Signal using 555 Timer',
'Obstacle Avoidance Robot without Controller',
'Line Following Robot without Controller',
],

    info: '32 hours/year · Weekly once · 45–60 min/session · Certificate of completion provided',
  },
  '5': {
    title: '5th Grade — Arduino & Control',
    projects: [
'LED Working with & without Resistor',
'Motor, Buzzer & LED Working',
'Motor, Buzzer & LED Working on Breadboard',
'LED, Motor & Buzzer Control using Switch',
'LED, Motor & Buzzer Control by Potentiometer',
'Voltage Regulator & Multimeter Working',
'Tinkercad Design & Simulation',
'Blinking of LED using Arduino',
'Integrating Potentiometer with Arduino',
'Distance Monitoring System',
'Obstacle Detection Alert System',
'Bluetooth Controlled Robot',
'Voice Controlled Robot',
'LED Control by Online',
'Wi-Fi Controlled LED ON/OFF System',
],

    info: '32 hours/year · Weekly once · 45–60 min/session · Certificate of completion provided',
  },
  '6': {
    title: '6th Grade — IoT Foundations',
    projects: [
'LED Working',
'Motor, Buzzer & LED Working',
'Motor & Buzzer Control with Switch',
'Motor, Buzzer & LED Working on Breadboard',
'Tinkercad Design & Simulation',
'Railway Signal using 555 Timer',
'Temperature Indicator using Thermistor',
'Transistor Switch Function',
'Blinking of LED using Arduino',
'Integrating Potentiometer with Arduino',
'Wi-Fi Controlled Robot',
'Obstacle Avoidance Robot',
'LED Control by Online',
'IoT Weather Monitoring Station',
'Smart Fire Alert System',
],

    info: '32 hours/year · Weekly once · 45–60 min/session · Certificate of completion provided',
  },
  '7': {
    title: '7th Grade — Smart Systems',
    projects: [
'Blinking LED',
'Motor, Buzzer & LED Working',
'Motor, Buzzer & LED Working on Breadboard',
'LED, Motor & Buzzer Control using Switch',
'LED, Motor & Buzzer Control by Potentiometer',
'Tinkercad Design & Simulation',
'Intruder Laser Security Alarm',
'Open Loop & Closed Loop Circuit',
'Blinking of LED using Arduino',
'Integrating Potentiometer with Arduino',
'Smart Parking Indicator',
'Security System',
'Line Following Robot Kit',
'Joystick Controlled Robot',
'WiFi LED Control',
],

    info: '32 hours/year · Weekly once · 45–60 min/session · Certificate of completion provided',
  },
  '8': {
    title: '8th Grade — Advanced IoT',
    projects: [
'Blinking LED',
'Motor, Buzzer & LED Working',
'Motor, Buzzer & LED Working on Breadboard',
'LED, Motor & Buzzer Control using Switch',
'LED, Motor & Buzzer Control by Potentiometer',
'Tinkercad Design & Simulation',
'ON/OFF Functionality using AND Gate',
'Automatic Rain Detection System',
'Arduino Integration with Stepper Motor',
'Human Following Robot Kit',
'Edge Detection Robot',
'ThingSpeak Integration & Control',
'Smart Weather Monitoring System',
'Smart Positioning System',
'Smart Gas Leakage Detection System',
],

    info: '32 hours/year · Weekly once · 45–60 min/session · Certificate of completion provided',
  },
  '9': {
    title: '9th Grade — Robotics & Health',
    projects: [
'Blinking LED',
'Motor, Buzzer & LED Working',
'Motor, Buzzer & LED Working on Breadboard',
'LED, Motor & Buzzer Control using Switch',
'LED, Motor & Buzzer Control by Potentiometer',
'Tinkercad Design & Simulation',
'Vero Board Working',
'ON/OFF Functionality using OR Gate',
'LCD Integration',
'I2C & SPI Communication',
'Bluetooth Controlled Robot',
'Gesture Controlled Robot',
'ThingSpeak Integration & Control',
'Smart Health Monitoring System',
'Bike Accident Alert Device',
],

    info: '32 hours/year · Weekly once · 45–60 min/session · Certificate of completion provided',
  },
};

function GradeDetail({ grade, onClose }) {
  const data = GRADE_DATA[grade];
  if (!data) return null;

  return (
    <div className="gd__overlay" onClick={onClose}>
      <div className="gd__box" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="gd__header">
          <h2 className="gd__title">
            {data.title} ({data.projects.length} Projects)
          </h2>
          <button className="gd__back" onClick={onClose}>← Back</button>
        </div>

        {/* Projects Grid */}
        <div className="gd__grid">
          {data.projects.map((project, i) => (
            <div key={i} className="gd__item">
              <span className="gd__num">{i + 1}</span>
              <span className="gd__project">{project}</span>
            </div>
          ))}
        </div>

        {/* Info Bar */}
        <div className="gd__info">
          {data.info}
        </div>

      </div>
    </div>
  );
}

export default GradeDetail;